module.exports = __webpack_public_path__ + "img/logofs_icon.6cdca618.svg";